var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.725V18.675C15.5 18.2416 16.7083 17.4083 17.625 16.175C18.5417 14.9416 19 13.5416 19 11.975C19 10.4083 18.5417 9.00831 17.625 7.77498C16.7083 6.54164 15.5 5.70831 14 5.27498V3.22498C16.0667 3.69164 17.75 4.73764 19.05 6.36298C20.35 7.98831 21 9.85898 21 11.975C21 14.091 20.35 15.962 19.05 17.588C17.75 19.214 16.0667 20.2596 14 20.725ZM3 15V8.99998H7L12 3.99998V20L7 15H3ZM14 16V7.94998C14.7833 8.31664 15.396 8.86664 15.838 9.59998C16.28 10.3333 16.5007 11.1333 16.5 12C16.5 12.85 16.279 13.6376 15.837 14.363C15.395 15.0883 14.7827 15.634 14 16Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeaker);
export default __webpack_public_path__ + "static/media/iconSpeaker.5ed849bfaea413b68b08bc07cbb205e6.svg";
export { ForwardRef as ReactComponent };